import * as styles from './styles';

const ContentContainer = () => {
  return (
    <div css={styles.textContainer}>
      <p css={styles.text}>연결에 실패했어요.</p>
      <p css={styles.text}>잠시 후 다시 요청해 주세요.</p>
    </div>
  );
};

export default ContentContainer;
